import React from "react";
import { Map, TourData } from "../../../Types";
import { useQueryClient } from "@tanstack/react-query";
import { UseAssetsQuery, UseDownloadAsset } from "../../../api/calls/Queries";
import { MapIcon } from "../../Icons/left-side-bar-icons";
import { AddIcon, EditPencil } from "../../Icons/gui-elements-icons";

const MapList = (props: {
  tourData: TourData;
  tourID: number;
  setPage: React.Dispatch<React.SetStateAction<1 | 2>>;
  setSelected: React.Dispatch<React.SetStateAction<number | undefined>>;
  selected: number | undefined;
}) => {
  const { maps } = props.tourData;

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "wrap",
        padding: "20px",
        gridGap: "20px",
      }}
    >
      {maps?.map((map) => (
        <ListEl
          key={map.id}
          setPage={props.setPage}
          setSelected={props.setSelected}
          tourData={props.tourData}
          tourID={props.tourID}
          selected={props.selected}
          map={map}
        />
      ))}
      <ListEl
        default
        tourID={props.tourID}
        tourData={props.tourData}
        setPage={props.setPage}
        setSelected={props.setSelected}
      />
    </div>
  );
};

const ListEl = (props: {
  default?: boolean;
  tourID: number;
  tourData: TourData;
  setPage: React.Dispatch<React.SetStateAction<1 | 2>>;
  setSelected: React.Dispatch<React.SetStateAction<number | undefined>>;
  selected?: number | undefined;
  map?: Map;
}) => {
  const queryClient = useQueryClient();

  const { data: assetList } = UseAssetsQuery(props.tourID, 2);

  const { data: imageBlob } = UseDownloadAsset(
    assetList?.find((one) => one.assetId === props.map?.assetId)?.assetKeyLow ||
      assetList?.find((one) => one.assetId === props.map?.assetId)?.assetKeyFull
  );

  const addNewMap = React.useCallback(() => {
    const randId = Math.floor(100000000 + Math.random() * 900000000);

    queryClient.setQueryData(["GetTour", props.tourID], {
      ...props.tourData,
      maps: [...props.tourData.maps!, { id: randId, title: "Nuova mappa" }],
    });
    props.setSelected(randId);
    props.setPage(2);
  }, [props, queryClient]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          overflow: "hidden",
          background: props.default ? "#fff" : "#2222",
          height: 100,
          width: 150,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          userSelect: "none",
          cursor: "pointer",
          border: "2px solid",
          borderColor:
            props.map?.id && props.map?.id === props.selected
              ? "#2d2e82"
              : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          backgroundImage: `url(${imageBlob})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center center",
        }}
        onClick={() => {
          if (props.default) {
            addNewMap();
          } else if (!props.default && props.map?.id !== -1) {
            props.setSelected(props.map?.id!);
          }
        }}
      >
        {props.default && (
          <AddIcon width={"5rem"} height={"5rem"} color="#2d2e82" />
        )}
        {!imageBlob && !props.default && (
          <MapIcon fill="#fff" width={"4rem"} height={"4rem"} />
        )}
      </div>

      <div
        style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          maxWidth: 150,
          userSelect: "none",

          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <p
          style={{
            margin: 0,
            width: "80%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {props.map?.title}
        </p>
        {!props.default && (
          <button
            style={{
              minWidth: 0,
              lineHeight: "1rem",
              padding: 5,
              border: 0,
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              props.setSelected(props.map?.id);
              props.setPage(2);
            }}
          >
            <EditPencil color="#222" />
          </button>
        )}
      </div>
    </div>
  );
};

// <button
//             id="file-upload"
//             style={{
//               flex: 1,

//               width: "100%",
//               maxWidth: "100%",
//               margin: 0,
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//
//           >
//             <p
//               style={{
//                 margin: 0,
//                 overflow: "hidden",
//                 width: "100%",
//                 textAlign: "left",
//                 whiteSpace: "nowrap",
//                 textOverflow: "ellipsis",
//               }}
//             ></p>

export default MapList;
